import {getCookie} from '../Utility/CookieUtility';

// @todo: add new countries here:
export const availableCountries = [
  'de', 'ch', 'at', 'fr', 'be', 'nl', 'lu', 'cn', 'sg', 'it', 'kn', 'ca', 'us', 'mx', 'pr', 'si', 'pl', 'th', 'my', 'hu', 'ro',
];

export function getCountryCode(): string {
  const body = document.querySelector('body');
  let country = body!.dataset.country ?? '';
  if (!country) {
    country = getCookieCountryCode();
    // country not found in cookie or in availableCountries
    if (country === '' || !availableCountries.includes(country)) {
      country = getBrowserLanguageCode();
    }
    body!.classList.add('country-' + country);
    body!.dataset.country = country;
  }
  return country;
}

export function getCountryCodeNoneFiltered() {
  return getCookieCountryCode() || getBrowserLanguageCode() || '';
}

export function isCountryInNorthAmerica(): boolean {
  return ['mx', 'pr', 'ca', 'us'].includes(getCountryCode());
}

function getBrowserLanguageCode(): string {
  let code = String(navigator.language || (<any>navigator).userLanguage || (<any>navigator).systemLanguage).toLowerCase();
  if (code.length === 5 && code.substr(2, 1) === '-') {
    code = code.substr(3, 2);
  }
  if (code.length !== 2) {
    code = '';
  }
  return code;
}

/**
 * The cookie country code was set by apache-server (based on GeoIP https://dev.maxmind.com/geoip/geoip2/geolite2/)
 */
export function getCookieCountryCode(): string {
  return getCookie('visitor_country_').toLowerCase() || getCookie('visitor_country').toLowerCase();
}
